import { Dialog, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import NumberFormat from 'react-number-format';

const FareConfirmModal = ({
  onCancel,
  onConfirm,
  selectedFare,
  isModalOpen,
  matchingFares,
  seatPrice,
  totalSeatCost,
}) => {
  const handleOk = (fare) => {
    onConfirm({ fare });
  };

  const getRelativePrice = (farePrice) =>
    farePrice - selectedFare.price + seatPrice - totalSeatCost;

  return (
    <Dialog maxWidth="xs" aria-labelledby="fare-confirmation-dialog-title" open={isModalOpen}>
      <DialogContent dividers>
        Do you want to switch to{' '}
        {`${`${selectedFare.cabinClassName} Cabin`} (${selectedFare.fareClass})`}
        ?
        <br />
        This will reset your current seat selections on ALL of your flights.
        <div className="mt-10 grid grid-col-2 gap-4">
          {matchingFares.map((fare) => (
            <Fragment key={fare.fareBasisCode}>
              <div>
                {`${fare.cabinClassName} Cabin`} ({fare.fareClass}
                )
                <br />
                <span className="text-xs">
                  {fare.isRefundable ? 'refundable' : 'non-refundable'}
                </span>
              </div>
              <div>
                <button
                  type="button"
                  onClick={() => handleOk(fare)}
                  className="bg-button-theme text-white px-4 py-1 rounded-md"
                >
                  Select (
                  <NumberFormat
                    value={getRelativePrice(fare.price)}
                    displayType="text"
                    thousandSeparator
                    prefix={getRelativePrice(fare.price) > 0 ? '+$' : '$'}
                    fixedDecimalScale="true"
                    decimalScale="2"
                  />
                  )
                </button>
              </div>
            </Fragment>
          ))}

          <a
            role="button"
            onClick={onCancel}
            tabIndex="-2"
            onKeyDown={onCancel}
            className="block underline text-theme mt-5 text-center col-span-2"
          >
            No, remain at{' '}
            {`${`${selectedFare.cabinClassName} Cabin`} (${selectedFare.fareClass}) - ${selectedFare.isRefundable ? 'refundable' : 'non-refundable'}`}
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};

FareConfirmModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool,
  seatPrice: PropTypes.number,
  totalSeatCost: PropTypes.number,
  selectedFare: PropTypes.shape({
    cabinClassName: PropTypes.string,
    fareClass: PropTypes.string,
    isRefundable: PropTypes.bool,
    price: PropTypes.number,
  }).isRequired,
  matchingFares: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

FareConfirmModal.defaultProps = {
  isModalOpen: true,
  seatPrice: 0,
  totalSeatCost: 0,
};

export default FareConfirmModal;
